<template>
    <m-pageframe title="Demos">
        <v-container class="py-6 px-4">
            <h1 class="mb-2">Select a Demo Experience</h1>

            <v-list>
                <v-list-item-group class="d-flex flex-column gap-1">
                    <v-tooltip
                        v-for="(demo, index) in visible_experiences"
                        :key="index"
                        :disabled="!demo.admin_only"
                        left
                    >
                        <template #activator="{ on, attrs }">
                            <v-list-item
                                :to="{ name: demo.route }"
                                class="shaded-light"
                                :class="demo.admin_only && 'restricted'"
                                link
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-list-item-avatar>
                                    <v-icon
                                        large
                                        :color="demo.iconColor || 'grey'"
                                    >{{ demo.icon }}</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>{{ demo.title }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ demo.description }}</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                        <span>Staff Only</span>
                    </v-tooltip>
                </v-list-item-group>
            </v-list>
        </v-container>
    </m-pageframe>
</template>

<script>
export default {
    name: "DemoSelector",

    data() {
        return {
            demo_experiences: [
                {
                    title: "Guest Check-In",
                    description: "Guest check-in process with a variety of consent gathering strategies.",
                    route: "search-forms-guest-check-in-demo-gateway",
                    icon: "mdi-account-check",
                    admin_only: false,
                },
                {
                    title: "Order Confirmation",
                    description: "Order confirmation process with a focus on user consent.",
                    route: "order-confirmation-demo-gateway",
                    icon: "mdi-package-variant-closed",
                    admin_only: false,
                },
                {
                    title: "Account Confirmation",
                    description: "CRM contact information verification via bulk messaging campaign.",
                    route: "crm-account-confirmation-demo-gateway",
                    icon: "mdi-account-details",
                    admin_only: true,
                },
                {
                    title: "Alcohol Promotion",
                    description: "An example of alcohol promotion via a simulated bulk messaging campaign, with experimental integrated messaging features.",
                    route: "alcohol-promo-demo-start",
                    icon: "mdi-bottle-wine",
                    admin_only: true,
                },
                {
                    title: "Alcohol Promotion (v3)",
                    description: "An example of alcohol promotion via a simulated bulk messaging campaign, with experimental integrated messaging and security features.",
                    route: "alcohol-promo-demo-start-v3",
                    icon: "mdi-bottle-wine",
                    admin_only: true,
                },
            ]
        };
    },

    computed: {
        is_auth_actor_system_admin() {
            return this.$rc.$state.isAuthActorSystemAdmin();
        },
        
        visible_experiences() {
            return this.demo_experiences.filter(demo => {
                if (demo.admin_only) {
                    return this.is_auth_actor_system_admin;
                }
                return true;
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.restricted {
  border-left: 3px solid var(--v-primary-base);
}
.container {
    max-width: 75rem;
    margin: 0 auto;
}
</style>